import request from "@/service";

/* 获取考勤表信息 */
export function attendanceInfo(data) {
  return request({
    url: "/study/class/attendance/attendanceInfo",
    method: "get",
    params: data,
  });
}

/* 批量下载学员考勤记录 */
export function exportAttendanceInfo(data) {
  return request({
    url: "/study/class/attendance/exportAttendanceInfo",
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8",
    },
    data,
  });
}
/* 批量下载考勤详情记录 */
export function exportAttendanceDetail(data) {
  return request({
    url: "/study/class/attendance/exportAttendanceDetail",
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8",
    },
    data,
  });
}
/* 批量下载学员成绩 */
export function exportExamDetail(data) {
  return request({
    url: "/study/class/exam/exportExamDetail",
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8",
    },
    data,
  });
}
/* 获取考勤详细信息 */
export function attendanceDetail(data) {
  return request({
    url: "/study/class/attendance/attendanceDetail",
    method: "get",
    params: data,
  });
}
/* 班级培训测试表分页列表 */
export function examPage(data) {
  return request({
    url: "/study/class/exam/examPage",
    method: "get",
    params: data,
  });
}
/* 学员成绩分页列表 */
export function examDetailPage(data) {
  return request({
    url: "/study/class/exam/examDetailPage",
    method: "get",
    params: data,
  });
}
/* 作业列表 */
export function workPage(data) {
  return request({
    url: "/study/class/work/workPage",
    method: "get",
    params: data,
  });
}
/* 学员作业列表 */
export function studentWorkPage(data) {
  return request({
    url: "/study/class/studentWork/studentWorkPage",
    method: "get",
    params: data,
  });
}

/* 获取考勤统计信息-qinzhaolin */
export function attendanceStatistics(data) {
  return request({
    url: "/study/class/attendance/attendanceStatistics",
    method: "get",
    params: data,
  });
}

/* 分页-退学人员名单-qinzl */
export function pageDropOutByParam(data) {
  return request({
    url: "/study/class/enroll/pageDropOutByParam",
    method: "get",
    params: data,
  });
}

/* 分页-请假人员名单-qinzl */
export function pageLeaveByParam(data) {
  return request({
    url: "/study/audit/enroll/pageLeaveByParam",
    method: "get",
    params: data,
  });
}

/* 学员数字画像动态表头-qinzhaolin */
export function getTableHead(data) {
  return request({
    url: "/study/class/exam/getTableHead",
    method: "get",
    params: data,
  });
}
